import { redirect } from 'react-router-dom';

import { BookingRouteError } from '../components/scheduling/BookingRouteError';
import { BOOKING_ROUTE_PATHS } from '../lib/scheduling/bookingHosts';
import {
  BookingNotFoundPage,
  BookingPage,
  CancelBookingPage,
  RescheduleBookingPage,
} from '../pages/public/booking';

const BOOKING_ERROR_ELEMENT = <BookingRouteError />;

export const bookingRoutes = [
  {
    path: '/',
    loader: () => redirect('https://ahoy.ai/'),
    errorElement: BOOKING_ERROR_ELEMENT,
  },
  {
    path: BOOKING_ROUTE_PATHS.shortCodeMeeting,
    element: <BookingPage />,
    errorElement: BOOKING_ERROR_ELEMENT,
  },
  {
    path: BOOKING_ROUTE_PATHS.bookBySlug,
    element: <BookingPage />,
    errorElement: BOOKING_ERROR_ELEMENT,
  },
  {
    path: BOOKING_ROUTE_PATHS.scheduleBySlug,
    element: <BookingPage />,
    errorElement: BOOKING_ERROR_ELEMENT,
  },
  {
    path: BOOKING_ROUTE_PATHS.cancelBooking,
    element: <CancelBookingPage />,
    errorElement: BOOKING_ERROR_ELEMENT,
  },
  {
    path: BOOKING_ROUTE_PATHS.rescheduleBooking,
    element: <RescheduleBookingPage />,
    errorElement: BOOKING_ERROR_ELEMENT,
  },
  {
    path: BOOKING_ROUTE_PATHS.gSlug,
    element: <BookingPage />,
    errorElement: BOOKING_ERROR_ELEMENT,
  },
  {
    path: BOOKING_ROUTE_PATHS.globalSlug,
    element: <BookingPage />,
    errorElement: BOOKING_ERROR_ELEMENT,
  },
  {
    path: '*',
    element: <BookingNotFoundPage />,
  },
];
